import { render, staticRenderFns } from "./MenuGivePoint.vue?vue&type=template&id=17a54d12&"
import script from "./MenuGivePoint.vue?vue&type=script&lang=ts&"
export * from "./MenuGivePoint.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports